module.exports = __webpack_public_path__ + "static/media/robo.111b6a65.png";